export default __webpack_public_path__ + "static/media/userImg.8d49e377.png";